import { FETCH_DISCOUNT, FETCH_DISCOUNT_FAIL, FETCH_DISCOUNT_VALID, DISCOUNT_RESET } from './types';
import { SLACK_WEBHOOKS  } from '../config';
import axios from 'axios';
import { SlackWebhook } from './utils';

/**
 * Fetch discount via Busabout API (BOOKING QUOTE API)
 *
 * @param {string} payload - booking payload.
 * @param {string} tourID - product tour id.
 * @param {string} currency - currency (GBP, AUD, USD, CAD).
 */
export function FetchDiscount(payload,currency){

  const discountURL = `${process.env.REACT_APP_BOOKING_API}/quote?currency=${currency}&api_token=${process.env.REACT_APP_API_TOKEN}`;


  const config = {
    headers:{
      'Content-Type': 'text/plain'
    },
    withCredentials: true
  };

  return (dispatch) => {
    axios.post(discountURL, payload, config)
    .then((data) => {
      dispatch({type:FETCH_DISCOUNT, payload:data});
    })
    .catch((err) => {
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! DISCOUNT API - ' + discountURL + " " + err}));
      dispatch({type:FETCH_DISCOUNT_FAIL});
      console.log(err);
    })
  }

}


/**
 * Discount Valid - specify discount validity
 *
 * @param {boolean} valid
 */
export function DiscountValid(valid){
  return dispatch => dispatch({type:FETCH_DISCOUNT_VALID, payload:valid});
}


/**
 * Discount reset
 */
 export function DiscountReset(){
   return dispatch => dispatch({type:DISCOUNT_RESET});
 }



// WEBPACK FOOTER //
// ./src/actions/discount.js